import { login, logout, getInfo, loginAs } from "@/api/login"
import { createInexistingPlannings } from "@/api/users"
import { getToken, setToken, removeToken } from "@/utils/auth"
import { resetRouter } from "@/router"
const user = {
  state: {
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    info: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // user login
    login({ commit }, userInfo) {
      const email = userInfo.email.trim()
      return new Promise((resolve, reject) => {
        login(email, userInfo.password)
          .then(response => {
            const token = response.access_token
            // sets token in cookies
            setToken(token)
            commit("SET_TOKEN", token)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // As an admin login as a pharmacist
    loginAs({ commit }, userInfo) {
      //const userId = userInfo.id
      return new Promise((resolve, reject) => {
        loginAs(userInfo)
          .then(response => {
            const token = response.access_token
            // sets token in cookies
            setToken(token)
            commit("SET_TOKEN", token)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // get user info
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then(response => {
            const data = Object.assign({}, response)
            if (data.role) {
              commit("SET_ROLES", [data.role])
            } else {
              reject("getInfo: role must be a non-null !")
            }
            delete data.role
            commit("SET_INFO", data)
            // commit("SET_NAME", data.name);
            // commit("SET_AVATAR", data.avatar);
            createInexistingPlannings(data.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // user logout
    logOut({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        logout(state.token, true)
          .then(() => {
            dispatch("resetToken")
            resetRouter()
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 前端 登出
    fedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "")
        removeToken()
        resolve()
      })
    },

    // remove token
    resetToken({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "")
        commit("SET_ROLES", [])
        removeToken()
        resolve()
      })
    }
  }
}

export default user
